module.exports = __webpack_public_path__ + "static/media/sort_event_ipad.84528fe5.png";